"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Session = /** @class */ (function () {
    function Session() {
    }
    /**
     * Outcomes
     */
    /**
     * Add an outcome with the provided name, captured against the current session.
     * @param  {string} name
     * @param  {(event:OutcomeEvent)=>void} handler
     * @returns void
     */
    Session.prototype.addOutcome = function (name, handler) {
        var sendOutcomeCallback = function (result) {
            if (handler) {
                handler(result);
            }
        };
        window.cordova.exec(sendOutcomeCallback, function () { }, "OneSignalPush", "addOutcome", [name]);
    };
    ;
    /**
     * Add a unique outcome with the provided name, captured against the current session.
     * @param  {string} name
     * @param  {(event:OutcomeEvent)=>void} handler
     * @returns void
     */
    Session.prototype.addUniqueOutcome = function (name, handler) {
        var sendUniqueOutcomeCallback = function (result) {
            if (handler) {
                handler(result);
            }
        };
        window.cordova.exec(sendUniqueOutcomeCallback, function () { }, "OneSignalPush", "addUniqueOutcome", [name]);
    };
    ;
    /**
     * Add an outcome with the provided name and value, captured against the current session.
     * @param  {string} name
     * @param  {string|number} value
     * @param  {(event:OutcomeEvent)=>void} handler
     * @returns void
     */
    Session.prototype.addOutcomeWithValue = function (name, value, handler) {
        if (typeof handler === "undefined") {
            handler = function () { };
        }
        if (typeof handler !== "function") {
            console.error("OneSignal: addOutcomeWithValue: must provide a valid callback");
            return;
        }
        var sendOutcomeWithValueCallback = function (result) {
            if (handler) {
                handler(result);
            }
        };
        window.cordova.exec(sendOutcomeWithValueCallback, function () { }, "OneSignalPush", "addOutcomeWithValue", [name, Number(value)]);
    };
    ;
    return Session;
}());
exports.default = Session;
